import { render, staticRenderFns } from "./VendorProfileMenu.vue?vue&type=template&id=4fa5a0f0"
import script from "./VendorProfileMenu.vue?vue&type=script&lang=ts"
export * from "./VendorProfileMenu.vue?vue&type=script&lang=ts"
import style0 from "./VendorProfileMenu.vue?vue&type=style&index=0&id=4fa5a0f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports